import { GlobalApplicationsPersonalMenuPersonalMenuDtoUserType } from '@ori/global-api-client-react';
import { z } from 'zod';

export const userSchema = z.object({
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  userType: z.nativeEnum(GlobalApplicationsPersonalMenuPersonalMenuDtoUserType),
  userHash: z.string(),
});

export type User = z.infer<typeof userSchema>;
